import {useState, useRef, useEffect} from 'react';
import {View, TextInput, Animated} from 'react-native';
import PropTypes from 'prop-types';

import sy from '~/styles';

import {Pressable, UploadAttachment} from '~/components/controls';

import SendIcon from '~/images/md-icons/send/materialicons/24px.svg';

const LINE_HEIGHT = 20;

const InputChat = (props) => {
  const {style, textStyle, onChange, onSend, onAttachment} = props;
  const message = props.message ?? '';

  const [lines, setLines] = useState(1);

  const cancelAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    if (message.length === 0) {
      setLines(1);
    }
  }, [message]);

  useEffect(() => {
    if (onAttachment) {
      // Skip the animation if onAttachment is set.
      return;
    }

    if (message.length) {
      Animated.timing(cancelAnim, {
        toValue: 100,
        duration: 250,
        useNativeDriver: true,
      }).start();
    } else {
      Animated.timing(cancelAnim, {
        toValue: 0,
        duration: 0,
        useNativeDriver: true,
      }).start();
    }
  }, [cancelAnim, message, onAttachment]);

  return (
    <View style={[sy['p-4'], sy['flex-row'], style]}>
      <View style={[sy['flex-1'], {display: 'block'}]}>
        <View
          style={[
            sy['flex-1'],
            sy['px-2'],
            {
              borderRadius: 10,
              backgroundColor: '#EBEBEB',
              height: lines * LINE_HEIGHT,
              boxSizing: 'content-box',
              paddingTop: 6,
              paddingBottom: 6,
            },
            textStyle,
          ]}>
          <TextInput
            style={[
              sy.regular,
              sy['flex-1'],
              {
                color: message.length > 0 ? '#4A4A49' : '#828282',
              },
            ]}
            multiline
            placeholder={'Typ een nieuw bericht'}
            value={message}
            onChangeText={(message) => onChange(message)}
            onContentSizeChange={({nativeEvent}) => {
              const {height} = nativeEvent.contentSize;
              setLines(Math.max(Math.ceil(height / LINE_HEIGHT), 1));
            }}
          />
        </View>
      </View>
      <Animated.View
        style={[
          {
            height: 32,
            paddingLeft: message.length || onAttachment ? 8 : 0,
            maxWidth: onAttachment ? 100 : cancelAnim,
          },
          sy['justify-center'],
          sy['overflow-hidden'],
          sy['self-end'],
        ]}>
        {(() => {
          if (message?.length > 0) {
            return (
              <Pressable
                onPress={() => {
                  onSend();
                  setLines(1);
                }}>
                <SendIcon fill="#231fda" />
              </Pressable>
            );
          }

          if (onAttachment) {
            return (
              <UploadAttachment
                onAttached={async (attachment) => {
                  onAttachment(attachment);
                }}
              />
            );
          }

          return null;
        })()}
      </Animated.View>
    </View>
  );
};

InputChat.propTypes = {
  message: PropTypes.string,
  style: PropTypes.any,
  textStyle: PropTypes.any,
  onChange: PropTypes.func,
  onSend: PropTypes.func,
  onAttachment: PropTypes.func,
};

export default InputChat;
